(function() {
  /** @type {HTMLElement|null} */
  var container = document.querySelector('[data-track-order-form]');
  if (!container) return;

  /** @type {HTMLFormElement|null} */
  var form = container.querySelector('[data-track-form]');
  /** @type {HTMLInputElement|null} */
  var input = container.querySelector('[name="tracking_number"]');
  /** @type {HTMLElement|null} */
  var submitText = container.querySelector('[data-submit-text]');
  /** @type {HTMLButtonElement|null} */
  var btn = container.querySelector('[data-track-submit]');
  /** @type {HTMLElement|null} */
  var errorEl = container.querySelector('[data-track-error]');
  /** @type {HTMLElement|null} */
  var modeToggle = container.querySelector('[data-search-mode]');
  var apiKey = container.getAttribute('data-api-key') || '';
  var apiPass = container.getAttribute('data-api-password') || '';
  var apiBase = container.getAttribute('data-api-base-url') || 'https://merchantapistaging.leopardscourier.com/api/';
  var apiProxy = container.getAttribute('data-api-proxy') || '';

  /** @type {HTMLElement|null} */
  var page = container.closest('[data-track-page]');
  /** @type {HTMLElement|null} */
  var loadingEl = page ? page.querySelector('[data-track-loading]') : null;
  /** @type {HTMLElement|null} */
  var resultsEl = page ? page.querySelector('[data-track-results]') : null;
  /** @type {HTMLTemplateElement|null} */
  var cardTpl = resultsEl ? resultsEl.querySelector('[data-track-result-template]') : null;
  /** @type {HTMLTemplateElement|null} */
  var timeTpl = resultsEl ? resultsEl.querySelector('[data-result-timeline-item]') : null;

  /** --- Verify Modal --- */
  var verifyModal = page ? page.querySelector('[data-verify-modal]') : null;
  var verifyBody = verifyModal ? verifyModal.querySelector('[data-verify-body]') : null;
  var verifyForm = verifyModal ? verifyModal.querySelector('[data-verify-form]') : null;
  var verifyInput = verifyModal ? verifyModal.querySelector('[name="verify_phone_input"]') : null;
  var verifyError = verifyModal ? verifyModal.querySelector('[data-verify-error]') : null;
  var verifyClose = verifyModal ? verifyModal.querySelectorAll('[data-verify-close]') : null;

  var searchMode = 'cn';
  var pendingOrderId = '';
  var verifiedOrders = {};
  var isLoading = false;

  function showVerifyError(msg) {
    if (!verifyError) return;
    verifyError.textContent = msg;
    verifyError.style.display = '';
  }

  function hideVerifyError() {
    if (verifyError) { verifyError.style.display = 'none'; verifyError.textContent = ''; }
  }

  function openVerifyModal() {
    if (!verifyModal || !verifyInput) return;
    hideVerifyError();
    verifyInput.value = '';
    if (verifyForm) verifyForm.style.display = '';
    var loadingEl2 = verifyBody ? verifyBody.querySelector('[data-verify-loading]') : null;
    if (loadingEl2) loadingEl2.style.display = 'none';
    verifyModal.hidden = false;
    setTimeout(function() { if (verifyInput) verifyInput.focus(); }, 100);
  }

  function closeVerifyModal() {
    if (verifyModal) verifyModal.hidden = true;
    isLoading = false;
    if (input) input.disabled = false;
    if (btn) btn.disabled = !input || input.value.trim() === '';
  }

  if (verifyClose) {
    for (var vc = 0; vc < verifyClose.length; vc++) {
      verifyClose[vc].addEventListener('click', closeVerifyModal);
    }
  }
  if (verifyModal) {
    verifyModal.addEventListener('click', function(e) {
      if (e.target === verifyModal) closeVerifyModal();
    });
  }

  function normalizePhone(num) {
    var n = (num || '').toString().replace(/[\s\-\(\)]/g, '');
    if (n.indexOf('+') === 0) n = '00' + n.substring(1);
    n = n.replace(/^0092/, '0').replace(/^92(?=[0-9])/, '0');
    return n.replace(/\D/g, '');
  }

  if (verifyForm) {
    verifyForm.addEventListener('submit', function(e) {
      e.preventDefault();
      if (!verifyInput || !pendingOrderId) return;
      var vError = verifyError;

      var rawPhone = verifyInput.value.trim();
      if (!rawPhone) { if (vError) { vError.textContent = 'Please enter your phone number'; vError.style.display = ''; } return; }
      if (vError) vError.style.display = 'none';

      var phone = normalizePhone(rawPhone);
      if (!phone || phone.length < 10) { if (vError) { vError.textContent = 'Please enter a valid phone number'; vError.style.display = ''; } return; }

      verifyForm.style.display = 'none';
      var loadingEl2 = verifyBody ? verifyBody.querySelector('[data-verify-loading]') : null;
      if (loadingEl2) loadingEl2.style.display = '';

      isLoading = true;
      shiftSearch(true);
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      if (input) input.disabled = true;
      if (errorEl) errorEl.style.display = 'none';

      var controller = new AbortController();
      var timeout = setTimeout(function() { controller.abort(); }, 15000);

      var verifyUrl, verifyOpts;
      if (apiProxy) {
        verifyUrl = apiProxy;
        verifyOpts = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ mode: 'order', number: pendingOrderId, phone: rawPhone }),
          signal: controller.signal
        };
      } else {
        verifyUrl = apiBase + 'getShipmentDetailsByOrderID/format/json/';
        verifyOpts = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ api_key: apiKey, api_password: apiPass, shipment_order_id: ['#' + pendingOrderId.replace(/^#/, '')] }),
          signal: controller.signal
        };
      }

      fetch(verifyUrl, verifyOpts)
      .then(function(r) {
        clearTimeout(timeout);
        return r.json();
      })
      .then(function(data) {
        if (data.status !== 1) throw new Error(data.error || 'No results');

        // When using proxy, phone verification is done server-side
        // When direct, verify phone here
        if (!apiProxy) {
          var shipmentList = data.data || data.shipment_list || [];
          if (!shipmentList.length) throw new Error('No shipment found for this Order ID');
          var order = shipmentList[0];
          var orderPhone = normalizePhone(order.consignment_phone || order.shipment_phone || '');
          if (orderPhone && phone !== orderPhone) {
            isLoading = false;
            shiftSearch(false);
            if (verifyForm) verifyForm.style.display = '';
            if (loadingEl2) loadingEl2.style.display = 'none';
            if (vError) { vError.textContent = 'Phone number does not match this order. Please check and try again.'; vError.style.display = ''; }
            if (btn) btn.disabled = false;
            if (input) input.disabled = false;
            return;
          }
          var trackNum = order.track_number;
          if (!trackNum) throw new Error('No tracking number found');
          var orderKey = '#' + pendingOrderId.replace(/^#/, '');
          verifiedOrders[orderKey] = trackNum;
          if (submitText) submitText.textContent = 'Track Now';
          isLoading = true;
          shiftSearch(true);
          if (loadingEl) loadingEl.style.display = 'block';
          if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
          if (input) input.disabled = true;
          doTrackByCN(trackNum);
        } else {
          isLoading = false;
          // Proxy already returned tracking data
          closeVerifyModal();
          if (data.packet_list && data.packet_list.length && resultsEl) {
            for (var pi = 0; pi < data.packet_list.length; pi++) {
              resultsEl.appendChild(buildCard(data.packet_list[pi]));
            }
            resultsEl.style.display = 'block';
            lockSearch();
            var orderKey = '#' + pendingOrderId.replace(/^#/, '');
            if (data.packet_list[0]) {
              verifiedOrders[orderKey] = data.packet_list[0].track_number;
            }
            if (submitText) submitText.textContent = 'Track Now';
          }
          isLoading = false;
          shiftSearch(false);
          if (loadingEl) loadingEl.style.display = 'none';
          if (btn) btn.disabled = false;
          if (input) input.disabled = false;
        }
      })
      .catch(function(err) {
        clearTimeout(timeout);
        isLoading = false;
        shiftSearch(false);
        if (verifyForm) verifyForm.style.display = '';
        if (loadingEl2) loadingEl2.style.display = 'none';
        var errMsg = err.message || 'Verification failed';
        if (vError) { vError.textContent = errMsg; vError.style.display = ''; }
        if (errorEl) { errorEl.textContent = errMsg; errorEl.style.display = 'block'; }
        if (btn) btn.disabled = false;
        if (input) input.disabled = false;
      });
    });
  }

  if (modeToggle) {
    var modes = modeToggle.querySelectorAll('[data-search-mode-btn]');
    for (var m = 0; m < modes.length; m++) {
      modes[m].addEventListener('click', function() {
        var mode = this.getAttribute('data-search-mode-btn');
        if (!mode) return;
        searchMode = mode;
        if (modeToggle) {
          var allBtns = modeToggle.querySelectorAll('[data-search-mode-btn]');
          for (var b = 0; b < allBtns.length; b++) {
            allBtns[b].classList.remove('active');
          }
          this.classList.add('active');
        }
        if (input) {
          input.placeholder = mode === 'cn' ? 'Enter tracking number' : 'Enter Order ID';
          input.value = '';
        }
        if (submitText) {
          submitText.textContent = mode === 'cn' ? 'Track Now' : 'Verify Phone';
        }
      });
    }
  }

  function doTrackByCN(trackNum) {
    var controller = new AbortController();
    var timeout = setTimeout(function() { controller.abort(); }, 15000);

    var url, fetchOpts;
    if (apiProxy) {
      url = apiProxy;
      fetchOpts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mode: 'cn', number: trackNum }),
        signal: controller.signal
      };
    } else {
      url = apiBase + 'trackBookedPacket/format/json/';
      fetchOpts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ api_key: apiKey, api_password: apiPass, track_numbers: trackNum }),
        signal: controller.signal
      };
    }

    fetch(url, fetchOpts)
    .then(function(r) {
      clearTimeout(timeout);
      if (!r.ok) throw new Error('API failed (' + r.status + ')');
      return r.json();
    })
    .then(function(data) {
      if (data.status !== 1 || !data.packet_list || !data.packet_list.length) throw new Error(data.error || 'No tracking results');
      if (resultsEl) {
        for (var i = 0; i < data.packet_list.length; i++) {
          resultsEl.appendChild(buildCard(data.packet_list[i]));
        }
        resultsEl.style.display = 'block';
        lockSearch();
      }
    })
    .catch(function(err) {
      if (errorEl) { errorEl.textContent = err.message || 'Request failed'; errorEl.style.display = 'block'; }
    })
    .finally(function() {
      isLoading = false;
      if (loadingEl) loadingEl.style.display = 'none';
      shiftSearch(false);
    });
  }

  if (input && btn) btn.disabled = true;

  if (input) {
    input.addEventListener('blur', function() {
      window.scrollTo(0, 20);
    });
    input.addEventListener('input', function() {
      var val = input.value.trim();
      if (btn) btn.disabled = val === '';
      if (searchMode === 'order' && submitText) {
        var orderKey = '#' + val.replace(/^#/, '');
        submitText.textContent = verifiedOrders[orderKey] ? 'Track Now' : 'Verify Phone';
      }
    });
  }

  var modeToggleEl = container.querySelector('[data-search-mode]');
  var searchOuter = container.closest('.track-search');

  function shiftSearch(shift) {
    if (searchOuter) searchOuter.style.marginTop = shift ? '24px' : '';
  }

  function lockSearch() {
    if (input) input.disabled = true;
    if (btn) {
      btn.classList.remove('is-loading');
      btn.classList.add('button--reset');
      btn.disabled = false;
    }
    if (submitText) submitText.textContent = 'Reset';
    if (modeToggleEl) modeToggleEl.style.display = 'none';
    shiftSearch(false);
    if (input) { input.blur(); input.disabled = true; }
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    var topOff = 20;
    window.scrollTo(0, topOff);
    var scrollFix = function() { window.scrollTo(0, topOff); };
    setTimeout(scrollFix, 400);
    setTimeout(scrollFix, 800);
  }

  function unlockSearch() {
    if (input) input.disabled = false;
    if (btn) {
      btn.classList.remove('button--reset');
      btn.disabled = false;
    }
    if (submitText) submitText.textContent = searchMode === 'cn' ? 'Track Now' : 'Verify Phone';
    if (modeToggleEl) modeToggleEl.style.display = '';
  }

  function resetAll() {
    if (isLoading) return;
    if (resultsEl) {
      while (resultsEl.firstChild) resultsEl.removeChild(resultsEl.firstChild);
      resultsEl.style.display = 'none';
    }
    isLoading = false;
    shiftSearch(false);
    if (errorEl) { errorEl.style.display = 'none'; errorEl.textContent = ''; }
    if (input) { input.value = ''; }
    unlockSearch();
    if (input && btn) { btn.disabled = true; btn.blur(); }
    verifiedOrders = {};
    var topOffset = 20;
    document.documentElement.scrollTop = topOffset;
    document.body.scrollTop = topOffset;
    window.scrollTo(0, topOffset);
    setTimeout(function() { document.documentElement.scrollTop = topOffset; }, 100);
  }

  if (!form) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    if (submitText && submitText.textContent === 'Reset') {
      resetAll();
      return;
    }
    e.preventDefault();
    if (isLoading) return;
    var val = input ? input.value.trim() : '';
    if (!val) return;

    if (errorEl) { errorEl.style.display = 'none'; errorEl.textContent = ''; }
    if (resultsEl) {
      while (resultsEl.firstChild) resultsEl.removeChild(resultsEl.firstChild);
      resultsEl.style.display = 'none';
    }

    if (searchMode === 'order') {
      var orderKey = '#' + val.replace(/^#/, '');
      if (verifiedOrders[orderKey]) {
        if (submitText) submitText.textContent = 'Track Now';
        isLoading = true;
        shiftSearch(true);
        if (loadingEl) loadingEl.style.display = 'block';
        if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
        if (input) input.disabled = true;
        doTrackByCN(verifiedOrders[orderKey]);
        return;
      }
      pendingOrderId = val;
      isLoading = true;
      openVerifyModal();
      return;
    }

    isLoading = true;
    shiftSearch(true);
    if (loadingEl) loadingEl.style.display = 'block';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    if (input) input.disabled = true;
    doTrackByCN(val);
  });

  function qs(el, sel) {
    if (el instanceof Element || el instanceof DocumentFragment) return el.querySelector(sel);
    return null;
  }

  function qsEl(el, sel) {
    if (el instanceof Element || el instanceof DocumentFragment) return /** @type {HTMLElement|null} */ (el.querySelector(sel));
    return null;
  }

  function buildCard(p) {
    var card = cardTpl ? cardTpl.content.cloneNode(true) : document.createElement('div');

    function setVal(sel, val) {
      var el = qsEl(card, sel);
      if (el) el.textContent = val != null ? String(val) : '-';
    }

    setVal('[data-result-track-number]', p.track_number);
    setVal('[data-result-order-id]', p.booked_packet_order_id ? 'Order ' + p.booked_packet_order_id : '');

    var badge = qsEl(card, '[data-result-status]');
    if (badge) {
      badge.innerHTML = '';
      badge.className = 'track-card__badge';
      var s = (p.booked_packet_status || '').toLowerCase();
      if (s.indexOf('delivered') >= 0 || s.indexOf('received') >= 0) {
        badge.classList.add('badge--delivered');
        var icon = document.createElement('span');
        icon.className = 'badge__icon';
        icon.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
        badge.appendChild(icon);
        var txt = document.createElement('span');
        txt.textContent = p.booked_packet_status || 'Delivered';
        badge.appendChild(txt);
      } else {
        badge.textContent = p.booked_packet_status || '-';
        if (s.indexOf('courier') >= 0 || s.indexOf('assign') >= 0 || s.indexOf('out for') >= 0 || s.indexOf('dispatched') >= 0) badge.classList.add('badge--courier');
        else if (s.indexOf('picked') >= 0 || s.indexOf('collected') >= 0) badge.classList.add('badge--picked');
        else if (s.indexOf('return') >= 0 || s.indexOf('cancel') >= 0 || s.indexOf('failed') >= 0) badge.classList.add('badge--return');
        else if (s.indexOf('intransit') >= 0 || s.indexOf('transit') >= 0 || s.indexOf('dispatch') >= 0 || s.indexOf('shipment') >= 0) badge.classList.add('badge--transit');
        else badge.classList.add('badge--default');
      }
    }

    setVal('[data-result-booking-date]', p.booking_date);
    setVal('[data-result-origin]', p.origin_city_name);
    setVal('[data-result-destination]', p.destination_city_name);
    setVal('[data-result-weight]', p.booked_packet_weight ? parseFloat(p.booked_packet_weight).toFixed(0) + 'g' : '-');
    setVal('[data-result-shipper]', p.shipment_name_eng);
    setVal('[data-result-shipper-phone]', p.shipment_phone);
    setVal('[data-result-shipper-email]', p.shipment_email);
    setVal('[data-result-shipper-address]', p.shipment_address);
    setVal('[data-result-consignee]', p.consignment_name_eng);
    setVal('[data-result-consignee-phone]', p.consignment_phone);
    setVal('[data-result-consignee-email]', p.consignment_email);
    setVal('[data-result-consignee-address]', p.consignment_address);
    setVal('[data-result-pieces]', p.booked_packet_no_piece || '-');
    setVal('[data-result-instructions]', p.special_instructions);
    var amt = p.booked_packet_collect_amount;
    var amtEl = qsEl(card, '[data-result-collect-amount]');
    if (amtEl) {
      if (amt && parseFloat(amt) > 0) {
        amtEl.textContent = parseFloat(amt).toFixed(2);
      } else {
        amtEl.textContent = 'Already Paid';
        amtEl.style.color = '#059669';
        amtEl.style.fontWeight = '600';
      }
    }

    var timeline = qsEl(card, '[data-result-timeline]');
    if (timeline && p['Tracking Detail'] && p['Tracking Detail'].length) {
      timeline.innerHTML = '';
      for (var k = 0; k < p['Tracking Detail'].length; k++) {
        var d = p['Tracking Detail'][k];
        var el = timeTpl ? timeTpl.content.cloneNode(true) : document.createElement('div');

        function setT(sel, val) {
          var e = qsEl(el, sel);
          if (e) e.textContent = val || '';
        }

        setT('[data-timeline-status]', d.Staus || d.Status || '');

        var cityEl = qsEl(el, '[data-timeline-city]');
        if (cityEl) {
          var ct = d.Status_With_City || '';
          if (ct && ct !== (d.Staus || d.Status)) { cityEl.textContent = ct; cityEl.style.display = ''; }
          else { cityEl.style.display = 'none'; }
        }

        var dtRaw = d.Activity_Date || d['Activity Date'] || '';
        var tmRaw = d.Activity_Time || d['Activity Time'] || '';
        var dateEl = qsEl(el, '[data-timeline-date-text]');
        if (dateEl) dateEl.textContent = tmRaw ? dtRaw + ' at ' + tmRaw : dtRaw;

        var reason = d.Reason || d['Reciever Name'] || '';
        var re = qsEl(el, '[data-timeline-reason]');
        if (re) {
          if (reason) {
            re.textContent = '';
            re.style.display = '';
            re.className = 'track-timeline__reason';
            var stLower = (d.Staus || d.Status || '').toLowerCase();
            if (stLower.indexOf('delivered') >= 0 || reason.toLowerCase().indexOf('self') >= 0 || reason.toLowerCase().indexOf('staff') >= 0 || reason.toLowerCase().indexOf('received') >= 0) {
              re.classList.add('track-timeline__reason--received');
              var label = reason;
              if (reason.toLowerCase().indexOf('self') >= 0) label = 'Received by Self';
              else if (reason.toLowerCase().indexOf('staff') >= 0) label = 'Received by Staff';
              else if (reason.toLowerCase().indexOf('received by') >= 0) label = reason;
              else label = 'Received by ' + reason;
              re.innerHTML = '<span class="track-timeline__reason-badge"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' + label + '</span>';
            } else {
              re.textContent = reason;
            }
          } else {
            re.style.display = 'none';
          }
        }

        if (el instanceof DocumentFragment) {
          var ch = /** @type {HTMLElement|null} */ (el.firstElementChild);
          if (ch) {
            ch.style.animationDelay = (k * 0.08) + 's';
            if (k === p['Tracking Detail'].length - 1) ch.classList.add('is-current');
          }
        }

        timeline.appendChild(el);
      }
    }

    var podField = qsEl(card, '[data-result-pod]');
    var podBtn = qsEl(card, '[data-pod-btn]');
    if (podField) {
      var st = (p.booked_packet_status || '').toLowerCase();
      if (st.indexOf('delivered') >= 0 || st.indexOf('received') >= 0) {
        podField.style.display = '';
        if (podBtn) {
          var trackNum = p.track_number;
          (function(cn) {
            podBtn.addEventListener('click', function() {
              openPOD(cn);
            });
          })(trackNum);
        }
      } else {
        podField.style.display = '';
        if (podBtn) podBtn.style.display = 'none';
        var podLabel = podField.querySelector('.track-card__field-label');
        var podVal = podField.querySelector('.track-card__field-value');
        if (podLabel) podLabel.textContent = 'Proof of Delivery';
        if (podVal) {
          podVal.textContent = 'Available after delivery';
          podVal.style.color = '';
          podVal.style.fontWeight = '';
          podVal.style.fontSize = '0.78rem';
          podVal.style.opacity = '0.45';
        }
      }
    }

    return card;
  }

  /** --- POD Modal --- */
  var modal = page ? page.querySelector('[data-track-modal]') : null;
  var modalBody = modal ? modal.querySelector('[data-modal-body]') : null;
  var modalClose = modal ? modal.querySelectorAll('[data-modal-close]') : null;

  function openPOD(cn) {
    if (!modal || !modalBody) return;
    modalBody.innerHTML = '<div style="padding:20px;text-align:center;opacity:0.5;font-size:0.9rem">Loading proof of delivery...</div>';
    modal.hidden = false;

    var podUrl, podOpts;
    if (apiProxy) {
      podUrl = apiProxy;
      podOpts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mode: 'pod', number: cn }),
      };
    } else {
      podUrl = apiBase + 'getElectronicProofOfDelivery/format/json/?api_key=' + encodeURIComponent(apiKey) + '&api_password=' + encodeURIComponent(apiPass) + '&cn_number=' + encodeURIComponent(cn);
      podOpts = {};
    }

    fetch(podUrl, podOpts)
      .then(function(r) {
        if (!r.ok) throw new Error('API failed (' + r.status + ')');
        return r.json();
      })
      .then(function(data) {
        if (data.status !== 1) throw new Error(data.error || 'No proof of delivery found');
        var items = data.data || data;
        var d = items;
        if (items && typeof items === 'object') {
          if (Array.isArray(items) && items.length > 0) {
            var first = items[0];
            if (first && typeof first === 'object') {
              var keys = Object.keys(first);
              var hasField = (first.Sig_Url !== undefined || first.Receiver_Name !== undefined || first.City_Name !== undefined || first.CN_Number !== undefined);
              d = hasField ? first : (keys.length > 0 ? first[keys[0]] : first);
            }
          } else {
            var objKeys = Object.keys(items);
            if (objKeys.length > 0) {
              var firstVal = items[objKeys[0]];
              if (firstVal && typeof firstVal === 'object' && (firstVal.City_Name !== undefined || firstVal.Receiver_Name !== undefined)) {
                d = firstVal;
              }
            }
          }
        }
        var html = '<div style="display:flex;flex-direction:column;gap:12px">';
        if (d && d.Sig_Url) {
          html += '<div style="padding:12px;background:var(--color-scheme-bg-secondary,#f8f9fb);border-radius:8px;text-align:center;border:1px solid var(--color-border,#e5e7eb)"><img src="' + d.Sig_Url.replace(/^http:/i, 'https:') + '" alt="Signature" style="max-height:80px;border-radius:4px;background:#fff" loading="lazy"></div>';
        }
        if (d) {
          html += '<div style="display:grid;grid-template-columns:1fr 1fr;gap:0;border:1px solid var(--color-border,#e5e7eb);border-radius:8px;overflow:hidden">';
          function fld(l, v) { return '<div style="padding:8px 12px;border-bottom:1px solid var(--color-border,#e5e7eb);border-right:1px solid var(--color-border,#e5e7eb)"><div style="font-size:0.68rem;text-transform:uppercase;letter-spacing:0.04em;opacity:0.4;font-weight:500;margin-bottom:1px">' + l + '</div><div style="font-size:0.84rem;font-weight:500">' + (v != null && v !== '' ? String(v) : '-') + '</div></div>'; }
          html += fld('CN Number', d.CN_Number);
          html += fld('Receiver Name', d.Receiver_Name);
          html += fld('Relation', d.Relation);
          html += fld('City', d.City_Name);
          html += fld('Arrival Date', d.Arrival_Date);
          html += fld('Status', d.Status);
          html += fld('Status Detail', d.Status_Detail);
          html += fld('Remarks', d.Remarks);
          html += fld('Courier', d.Cour_Name);
          html += fld('Weight', d.Weight);
          html += fld('Pieces', d.Pcs);
          html += fld('Reason', d.Reason);
          html += fld('Latitude', d.Latitude);
          html += fld('Longitude', d.Longitude);
          html += '</div>';
        }
        html += '</div>';
        modalBody.innerHTML = html;
      })
      .catch(function(err) {
        modalBody.innerHTML = '<div style="padding:12px 16px;border-radius:8px;background:#fef2f2;color:#dc2626;font-size:0.85rem;border:1px solid #fecaca">' + (err.message || 'Failed to fetch proof of delivery') + '</div>';
      });
  }

  if (modalClose) {
    for (var mc = 0; mc < modalClose.length; mc++) {
      modalClose[mc].addEventListener('click', function() {
        if (modal) modal.hidden = true;
      });
    }
  }

  if (modal) {
    modal.addEventListener('click', function(e) {
      if (e.target === modal) modal.hidden = true;
    });
  }
})();
